import { S3_BUCKET_URL } from '@/constants.ts';

import { CloseLeanScreen } from '../OwnAiMan_Roleplay/screens/CloseLeanScreen';
import { DrinkOfferScreen } from '../OwnAiMan_Roleplay/screens/DrinkOfferScreen';
import { ElevatorCloseScreen } from '../OwnAiMan_Roleplay/screens/ElevatorCloseScreen';
import { ElevatorSilenceScreen } from '../OwnAiMan_Roleplay/screens/ElevatorSilenceScreen';
import { ScreenEmail } from '../OwnAiMan_Roleplay/screens/Email';
import { EntranceScreen } from '../OwnAiMan_Roleplay/screens/EntranceScreen';
import { EyeContactScreen } from '../OwnAiMan_Roleplay/screens/EyeContactScreen';
import { FinalConsentScreenA } from '../OwnAiMan_Roleplay/screens/FinalConsentSceneA';
import { FinalConsentScreenB } from '../OwnAiMan_Roleplay/screens/FinalConsentScreenB';
import { IntentQuestionScreen } from '../OwnAiMan_Roleplay/screens/IntentQuestionScreen';
import { InviteOverScreen } from '../OwnAiMan_Roleplay/screens/InviteOverScreen';
import { LiftUpScreen } from '../OwnAiMan_Roleplay/screens/LiftUpScreen';
import { NeckBreathScreen } from '../OwnAiMan_Roleplay/screens/NeckBreathScreen';
import { ShakingScreen } from '../OwnAiMan_Roleplay/screens/ShakingScreen';
import { StillSureScreen } from '../OwnAiMan_Roleplay/screens/StillSureScreen';
import { UnbuttonShirtScreen } from '../OwnAiMan_Roleplay/screens/UnbuttonShirtScreen';
import { WaistGrabScreen } from '../OwnAiMan_Roleplay/screens/WaistGrabScreen';
import { WelcomeScreen } from '../OwnAiMan_Roleplay/screens/Welcome';

import { LayoutDataType } from './types';

export const layoutSteps = {
  welcome: {
    component: WelcomeScreen,
    images: [],
  },
  entrance: {
    component: EntranceScreen,
    images: [`${S3_BUCKET_URL}/layout-own-ai-man-roleplay/entrance-screne.png`],
  },
  eye_contact: {
    component: EyeContactScreen,
    images: [
      `${S3_BUCKET_URL}/layout-own-ai-man-roleplay/eye-contact-scene.png`,
    ],
  },
  drink_offer: {
    component: DrinkOfferScreen,
    images: [
      `${S3_BUCKET_URL}/layout-own-ai-man-roleplay/drink-offer-scene.png`,
    ],
  },
  intent_question: {
    component: IntentQuestionScreen,
    images: [
      `${S3_BUCKET_URL}/layout-own-ai-man-roleplay/intent-question-scene.png`,
    ],
  },
  close_lean: {
    component: CloseLeanScreen,
    images: [
      `${S3_BUCKET_URL}/layout-own-ai-man-roleplay/close-lean-scene.png`,
    ],
  },
  invite_over: {
    component: InviteOverScreen,
    images: [
      `${S3_BUCKET_URL}/layout-own-ai-man-roleplay/invite-over-scene.png`,
    ],
  },
  elevator_silence: {
    component: ElevatorSilenceScreen,
    images: [
      `${S3_BUCKET_URL}/layout-own-ai-man-roleplay/elevator-silence-scene.png`,
    ],
  },
  elevator_close: {
    component: ElevatorCloseScreen,
    images: [
      `${S3_BUCKET_URL}/layout-own-ai-man-roleplay/elevator-close-scene.png`,
    ],
  },
  unbutton_shirt: {
    component: UnbuttonShirtScreen,
    images: [
      `${S3_BUCKET_URL}/layout-own-ai-man-roleplay/unbutton-shirt-scene.png`,
    ],
  },
  still_sure: {
    component: StillSureScreen,
    images: [
      `${S3_BUCKET_URL}/layout-own-ai-man-roleplay/still-sure-scene.png`,
    ],
  },
  waist_grab: {
    component: WaistGrabScreen,
    images: [
      `${S3_BUCKET_URL}/layout-own-ai-man-roleplay/waist-grab-scene.png`,
    ],
  },
  neck_breath: {
    component: NeckBreathScreen,
    images: [
      `${S3_BUCKET_URL}/layout-own-ai-man-roleplay/neck-breath-scene.png`,
    ],
  },
  shaking: {
    component: ShakingScreen,
    images: [`${S3_BUCKET_URL}/layout-own-ai-man-roleplay/shaking-scene.png`],
  },
  lift_up: {
    component: LiftUpScreen,
    images: [`${S3_BUCKET_URL}/layout-own-ai-man-roleplay/lift-up-scene.png`],
  },
  final_consent_screen_a: {
    component: FinalConsentScreenA,
    images: [
      `${S3_BUCKET_URL}/layout-own-ai-man-roleplay/final-consent-scene-a.png`,
    ],
  },
  final_consent_screen_b: {
    component: FinalConsentScreenB,
    images: [
      `${S3_BUCKET_URL}/layout-own-ai-man-roleplay/final-consent-scene-b.png`,
    ],
  },
  email: {
    component: ScreenEmail,
    images: [`${S3_BUCKET_URL}/layout-own-ai-man-roleplay/email.png`],
  },
};

export const layoutStepsKeys = Object.keys(layoutSteps);

export const layoutDataDefault: LayoutDataType = {
  name: '',
  email: '',
};

// Category constants - not used, already hardcoded in DrinkOffer screen
export const HARDCODED_CATEGORIES = [];
